import React, { useEffect, useState } from 'react';
import Table from '../components/atoms/Table';
import Input, { InputStyle } from '../components/atoms/Input';
import Button from '../components/atoms/Button';
import PopupTemp from './PopupTemp';
import DaumPostcodeEmbed from 'react-daum-postcode';
import LabelElement from '../components/molcures/LabelElement';
import styled from 'styled-components';
import IcoClose from '../assets/images/button/ico-pop-close.svg';
import axios from 'axios';
import OlAddress from '../ol/OlAddress';
import OlCore from '../ol/OlCore';
import ObjectPolygon from '../ol/Object/ObjectPolygon';
import ObjectSite from '../ol/Object/_old/ObjectSite';
import ObjectHQ from '../ol/Object/ObjectHQ';
import ObjectWater from '../ol/Object/ObjectWater';
import ObjectSpace from '../ol/Object/ObjectSpace';
import ObjectPoint from '../ol/Object/ObjectPoint';
import ObjectPhoto from '../ol/Object/ObjectPhoto';
import MeasureModule from '../ol/Layer/MeasureModule';
import { transWgsTo5186 } from '../ol/projection';
import { useSiteAdd } from '../hooks/RQuery/utils/sites';
import { sites } from '../hooks/RQuery/service/apiUrl';
import { useRecoilState } from 'recoil';
import { confirmState } from '../store/Atoms';

const PostPopStyle = {
  Dimmed: styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    background: rgba(0, 0, 0, 0.5);
  `,
  Wrap: styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  `,
  Head: styled.div`
    height: 50px;
    background: #fff;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
  `,
  Title: styled.strong`
    color: #192640;
    font-size: 18px;
    font-weight: 600;
  `,
  Close: styled.button`
    width: 24px;
    height: 24px;
    background: url(${IcoClose}) no-repeat center;
  `,
};

const PopupSiteAdd = ({ onPopupState }) => {
  const memberId = sessionStorage.getItem('memberId')!;
  const [isAddrStatus, setIsAddrStatus] = useState('daum');
  const [addr, setAddr] = useState('');
  const [coordAddr, setCoordAddr] = useState('');
  const [popState, setPopState] = useState({
    address: false,
  });
  const [coordinates, setCoordinates] = useState([128, 36]);
  const [isObjectReady, setIsObjectReady] = useState(false);
  const [mapInstance, setMapInstance] = useState<OlAddress>();

  const [siteData, setSiteData] = useState({
    siteName: '',
    siteAlias: '',
    geometry: { lat: 0, lon: 0 },
    memo: '',
  });
  const { mutate: siteAdd } = useSiteAdd({ memberId });
  const [confirm, setConfirm] = useRecoilState(confirmState);

  // 현장 추가
  const onAddSite = () => {
    siteAdd(
      { siteName: siteData.siteName, siteAddress: addr, siteAlias: siteData.siteAlias, geometry: { lat: siteData.geometry.lat, lon: siteData.geometry.lon }, memo: siteData.memo },
      {
        onSuccess: (res: any) => {
          setConfirm({
            ...confirm,
            text: res.message || '현장 등록이 완료되었습니다.',
            submitFunc: () => {
              setConfirm({ ...confirm, text: '' });
              onPopupState('siteAdd');
            },
          });
        },
        onError: (err: any) => {
          setConfirm({
            ...confirm,
            text: err.response.data.message || '현장 등록 실패. 관리자에게 문의하세요.',
            submitFunc: () => {
              setConfirm({ ...confirm, text: '' });
            },
          });
        },
      },
    );
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setSiteData({ ...siteData, [name]: value });
  };

  const onPopToggle = (key: string) => {
    setPopState({ ...popState, [key]: !popState[key] });
  };

  const completeHandler = (data) => {
    const { address, zonecode } = data;
    setAddr(address);
    setPopState({ ...popState, address: false });
  };

  useEffect(() => {
    if (!document.querySelector('#mapAddrContainer > .ol-viewport')) {
      const core = new OlAddress();

      setMapInstance(core);
      setIsObjectReady(true);
    }
  }, []);

  useEffect(() => {
    if (isObjectReady) {
      mapInstance?.clickMap(setCoordinates);
    }
  }, [isObjectReady]);

  useEffect(() => {
    if (addr) {
      axios
        .get('https://dapi.kakao.com/v2/local/search/address.json', {
          params: {
            query: addr,
            page: 1,
            size: 10,
          },
          headers: {
            Authorization: 'KakaoAK c4432a12da23b97abb7cbed33eedce16',
          },
        })
        .then((res) => {
          const data = res.data.documents[0];
          const x = Number(data.x);
          const y = Number(data.y);
          mapInstance?.setMarker([x, y]);
          setSiteData({ ...siteData, geometry: { lat: y, lon: x } });
          setIsAddrStatus('daum');
        });
    }
  }, [addr]);

  useEffect(() => {
    if (coordinates.length) {
      axios
        .get('https://dapi.kakao.com/v2/local/geo/coord2address.json', {
          params: {
            x: coordinates[0],
            y: coordinates[1],
            input_coord: 'WGS84',
          },
          headers: {
            Authorization: 'KakaoAK c4432a12da23b97abb7cbed33eedce16',
          },
        })
        .then((res) => {
          setCoordAddr(res.data.documents[0]?.address?.address_name || '');
          setIsAddrStatus('coord');
          setAddr(res.data.documents[0]?.address?.address_name || '');
          setSiteData({ ...siteData, geometry: { lat: coordinates[1], lon: coordinates[0] } });
        });
    }
  }, [coordinates]);
  return (
    <>
      <PopupTemp width={878} title={'현장추가'} onClose={() => onPopupState('siteAdd')}>
        <Table
          caption={'현장추가'}
          type={'row'}
          colgroup={[120, 'auto']}
          tbody={
            <>
              <tr>
                <th scope={'row'}>현장명</th>
                <td style={{ padding: 10, height: 47 }}>
                  <Input type={'text'} height={48} width={'100%'} placeholder={'현장명을 입력하세요'} onChange={onChange} name={'siteName'} />
                </td>
              </tr>
              <tr>
                <th scope={'row'}>별칭</th>
                <td style={{ padding: 10, height: 47 }}>
                  <Input type={'text'} height={48} width={'100%'} onChange={onChange} name={'siteAlias'} />
                </td>
              </tr>
              <tr>
                <th scope={'row'}>현장주소</th>
                <td style={{ padding: 10, height: 47 }}>
                  <div style={{ display: 'flex' }}>
                    <Input type={'text'} height={48} width={'100%'} value={isAddrStatus === 'daum' ? addr : coordAddr} />
                    <Button $isGradientBtn={true} text={'검색'} width={110} height={46} onClick={() => onPopToggle('address')} />
                  </div>
                </td>
              </tr>
              {/*<tr>*/}
              {/*  <th scope={'row'}>상세주소</th>*/}
              {/*  <td style={{ padding: 10, height: 47 }}>*/}
              {/*    <div style={{ display: 'flex' }}>*/}
              {/*      <Input type={'text'} height={48} width={'100%'} />*/}
              {/*    </div>*/}
              {/*  </td>*/}
              {/*</tr>*/}
              <tr>
                <th scope={'row'}>주소 직접선택</th>
                <td style={{ padding: 10 }}>
                  <div id={'mapAddrContainer'} style={{ width: '100%', height: 300 }}></div>
                </td>
              </tr>
              <tr>
                <th scope={'row'}>메모</th>
                <td style={{ padding: 10 }}>
                  <Input type={'text'} height={48} width={'100%'} onChange={onChange} name={'memo'} />
                </td>
              </tr>
            </>
          }
        />
        <div style={{ marginTop: 28, textAlign: 'right' }}>
          <Button $isGradientBtn={true} text={'추가'} width={110} height={50} onClick={onAddSite} />
        </div>
      </PopupTemp>
      {popState.address && (
        <>
          <PostPopStyle.Dimmed></PostPopStyle.Dimmed>
          <PostPopStyle.Wrap>
            <PostPopStyle.Head>
              <PostPopStyle.Title>주소 검색</PostPopStyle.Title>
              <PostPopStyle.Close type={'button'} onClick={() => onPopToggle('address')}>
                <span className={'hidden'}></span>
              </PostPopStyle.Close>
            </PostPopStyle.Head>
            <DaumPostcodeEmbed style={{ height: 600 }} onComplete={completeHandler} />
          </PostPopStyle.Wrap>
        </>
      )}
    </>
  );
};

export default PopupSiteAdd;
